import React, { useEffect, useState } from 'react';
import { fetchCategoriesWithPodcasts } from '../redux/actions/app-actions';
import { firebase } from '../firebase';

interface Category {
  category: string;
  categoryId: string;
  categoryImageUrl: string | null;
  podcasts: PodcastType[];
}

interface PodcastType {
  podcastId: string;
  imgUrl: string;
  category: string;
  categoryId: string;
  name: string;
}

interface UseFetchCategoriesResult {
  loading: boolean;
  data: Category[] | PodcastType[];
  setData: React.Dispatch<React.SetStateAction<Category[] | PodcastType[]>>;
  fetchData: (forceReload: boolean) => Promise<void>;
}

const useFetchCategories = (
  categoriesWithPodcasts: Category[],
  updateCategories: (data: Category[]) => void
): UseFetchCategoriesResult => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<Category[] | PodcastType[]>([]);

  const fetchData = async (forceReload: boolean): Promise<void> => {
    setLoading(true);

    try {
      if (firebase.auth.currentUser) {
        const token = await firebase.auth.currentUser.getIdToken();
        const res = await fetchCategoriesWithPodcasts(token, forceReload);

        updateCategories(res);
        const { data } = res;
        setData(data);
        setLoading(false);
      }
    } catch (error) {
      setData([]);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (categoriesWithPodcasts.length === 0) {
      fetchData(false);
    } else {
      setData(categoriesWithPodcasts);
      setLoading(false);
    }
  }, []);

  return { loading, data, setData, fetchData };
};

export default useFetchCategories;
